import React from 'react';

function Heading() {
  return (
      <div className="flex-center flex-col gap-base pt-base px-xl">
        <div className='heading-1'>Download YTS YIFY movies: HD smallest size</div>
        <div className="highlight neutral-500 w-9-12 text-center">Welcome to the official MOVIEBASE website. Here you can browse and download movies in excellent 720p, 1080p, 2160p 4K and 3D quality, all at the smallest file size. YTS Movies Torrents.</div>
        <div className='highlight-bold color-primary text-center'>IMPORTANT - MOVIEBASE is developed using official YTS API</div>
      </div>
  );
}

export default Heading;
